export const tr = {
    'add-button': 'Ekle',
    'cancel-button': 'İptal',
    'select-campaigns': 'Kampanya seçimi',
    'select-campaigns-and-groups': 'Kampanya ve grup seçimi'
};
